import Config from '../Config';
export const getItem = (sKey) => {
  return (
    decodeURIComponent(
      document.cookie.replace(
        new RegExp('(?:(?:^|.*;)\\s*' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'),
        '$1'
      )
    ) || null
  );
};
export const setItem = (sKey, sValue, vEnd, sPath, sDomain, bSecure) => {
  if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
    return false;
  }
  var sExpires = '';
  if (vEnd) {
    switch (vEnd.constructor) {
      case Number:
        sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
        break;
      case String:
        sExpires = '; expires=' + vEnd;
        break;
      case Date:
        sExpires = '; expires=' + vEnd.toUTCString();
        break;
    }
  }
  document.cookie =
    encodeURIComponent(sKey) +
    '=' +
    encodeURIComponent(sValue) +
    sExpires +
    (sDomain ? '; domain=' + sDomain : '') +
    (sPath ? '; path=' + sPath : '') +
    (bSecure ? '; secure' : '');
  return true;
};
export const removeCookieItem = async (sKey, sPath, sDomain) => {
  document.cookie =
    encodeURIComponent(sKey) +
    '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
    (sDomain ? '; domain=' + sDomain : '') +
    (sPath ? '; path=' + sPath : '');
  return true;
};
export const hasItem = (sKey) => {
  return new RegExp('(?:^|;\\s*)' + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=').test(document.cookie);
};
export const keys = () => {
  var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, '').split(/\s*(?:\=[^;]*)?;\s*/);
  for (var LnIdx = 0; nIdx < aKeys.length; nIdx++) {
    aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]);
  }
  return aKeys;
};

export const saveCookie = (name, value, path, expirationSeconds, secure) => {
  const cookiePath = path || '/';
  const cookieDomain = Config.environmentCookieDomain;
  const cookieSecure = !!secure;
  var expirationDate = new Date();
  if (expirationSeconds > 0) {
    expirationDate.setSeconds(expiration.getSeconds() + expirationSeconds);
  }
  setItem(name, value, expirationDate, cookiePath, cookieDomain, cookieSecure);
};
export const saveLoginCookie = (data) => {
  const cookieName = 'HttpModuleLoginCookie';
  const cookieDomain = Config.environmentCookieDomain;
  const cookiePath = '/';

  let expirationDate = new Date();
  expirationDate.setSeconds(expirationDate.getSeconds() + data.token.expires_in);
  var cookieExpiration = expirationDate.toUTCString();
  expirationDate = expirationDate.toJSON();

  const createDate = new Date().toJSON();
  const token = data.token.access_token;
  const refreshToken = data.token.refresh_token;
  const scopes = data.token.scopes?.join();
  const cookieValue = `CreateDate=${createDate}&ExpirationDate=${expirationDate}&Token=${token}&RefreshToken=${refreshToken}&Scopes=${scopes}`;

  document.cookie = `${cookieName}=${cookieValue};domain=${cookieDomain};path=${cookiePath};expires=${cookieExpiration}`;
};

export const isCookieProtected = (name) => {
  if (!name) {
    return false;
  }
  if (Config.protectedCookies?.includes(name)) {
    return true;
  }
  return (Config.protectedCookiesPatterns || []).some((pattern) => {
    if (!pattern || typeof pattern !== 'string') {
      return false;
    }
    try {
      return new RegExp(pattern).test(name);
    } catch {
      return false;
    }
  });
};

export const deleteAllCookies = () => {
  var cookies = document.cookie.split(';');
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf('=');
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    if (isCookieProtected(name?.trim())) {
      continue;
    }
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.' +window.location.hostname+ ';';
  }
};
